// The merge window is deliberately not here. It lived in this file and again
// in mobile/src/activity.ts, both mirroring clusterMergeWindowSeconds by hand;
// the server now sends settled_at already computed, so an installed build
// cannot hold a stale copy of it.

// How often camera health is re-fetched. Slower than a detection needs to be:
// a camera going down is a minutes-scale event, and the backend settles a
// status change over 70s before reporting it anyway.
export const HEALTH_POLL_MS = 30_000

// How often live view asks who holds the camera's speaker. Answered from
// memory on the server, never across WireGuard, so it can be quick.
export const SPEAKER_POLL_MS = 2_000
